<template>
  <div class="app-platform-reviews-count">
    <div class="app-platform-reviews-count__container">
      <div class="app-platform-reviews-count__star-rating">
        <rating-stars
          class="mr-2"
          :mark="starRating" />

        <span
          class="app-platform-reviews-count__star-rating-label">
          {{ starRatingLocalized }} {{ $t("stars") }}
        </span>
      </div>

      <div class="app-platform-reviews-count__reviews-count">
        {{ reviewsCount }} {{ $t("reviews") }}
      </div>

      <img
        class="app-platform-reviews-count__platform-badge"
        :src="platformIcon"
        :alt="platformIconAltText">
    </div>
  </div>
</template>

<script>
import appStoreIcon from "@/pages/book/components/images/platform-icons/ios.svg";
import googlePlayIcon from "@/pages/book/components/images/platform-icons/android.svg";
import RatingStars from "@/features/smartbanner/components/rating_stars";
import globals from "@/utils/globals";
import getLocale from "@/utils/locale";

export default {
  name: "AppPlatformReviewsCount",
  components: {
    RatingStars
  },
  props: {
    platform: {
      type: String,
      default: null
    }
  },
  computed: {
    platformIcon() {
      return {
        "ios": appStoreIcon,
        "android": googlePlayIcon
      }[this.platform];
    },
    platformIconAltText() {
      return {
        "ios": "App Store icon",
        "android": "Google Play icon"
      }[this.platform];
    },
    starRating() {
      return globals.smartbanner.rating[this.platform].stars;
    },
    starRatingLocalized() {
      let rating;

      if (this.starRating) {
        rating = this.starRating.toString();
      } else {
        rating = "4.5";
      }

      if (getLocale() === "de") {
        rating = rating.replace(".", ",");
      }

      return rating;
    },
    reviewsCount() {
      return globals.smartbanner.rating[this.platform].raw_count;
    }
  },
  i18n: {
    messages: {
      en: {
        stars: "Stars",
        reviews: "Reviews"
      },
      de: {
        stars: "Sterne",
        reviews: "Rezensionen"
      }
    }
  }
};
</script>

<style lang="scss">
.app-platform-reviews-count {
  @include font-family(sans-serif);

  padding: $spacing-32;

  background-color: $pale-mint-grey;

  border-radius: $spacing-4;

  &__star-rating {
    display: flex;
    justify-content: center;
    margin-bottom: $spacing-8;
  }

  &__star-rating-label {
    @include font-style(h5, $weight: bold);
  }

  &__reviews-count {
    @include font-style((xs: h3, m: h2), $weight: bold);

    margin-bottom: $spacing-16;

    text-align: center;
  }

  &__platform-badge {
    display: block;
    margin: 0 auto;
  }

  @include media(min-width, m) {

    &__star-rating {
      margin-bottom: $spacing-16;
    }

    &__reviews-count {
      margin-bottom: $spacing-24;
    }
  }
}
</style>
